import React from 'react'

const UXDesign = () => {
  return (
    <div className="skills__content">
        <h3 className="skills__title">UX, Accessibility & Quality</h3>

        <div className="skills__box">
            <div className="skills__group">

                <div className="skills__data">
                <i className='bx bx-badge-check'></i>

                    <div>
                        <h3 className="skills__name">Responsive design</h3>
                        <span className="skills__level">Cross-device delivery</span>
                    </div>
                </div>

                <div className="skills__data">
                <i className='bx bx-badge-check'></i>

                    <div>
                        <h3 className="skills__name">Accessibility</h3>
                        <span className="skills__level">WCAG-minded implementation</span>
                    </div>
                </div>

                <div className="skills__data">
                <i className='bx bx-badge-check'></i>

                    <div>
                        <h3 className="skills__name">SEO & performance</h3>
                        <span className="skills__level">Lighthouse optimization</span>
                    </div>
                </div>

                <div className="skills__data">
                <i className='bx bx-badge-check'></i>

                    <div>
                        <h3 className="skills__name">Figma</h3>
                        <span className="skills__level">Wireframes and prototypes</span>
                    </div>

                </div>

            </div>
            <div className="skills__group">
                <div className="skills__data">
                <i className='bx bx-badge-check'></i>

                    <div>
                        <h3 className="skills__name">Usability testing</h3>
                        <span className="skills__level">Task and interface validation</span>
                    </div>

                </div>

                <div className="skills__data">
                <i className='bx bx-badge-check'></i>

                    <div>
                        <h3 className="skills__name">Collaboration</h3>
                        <span className="skills__level">Design, accounts, and delivery teams</span>
                    </div>

                </div>

                <div className="skills__data">
                <i className='bx bx-badge-check'></i>

                    <div>
                        <h3 className="skills__name">Adobe XD</h3>
                        <span className="skills__level">UX design and prototyping</span>
                    </div>

                </div>
            </div>
        </div>
    </div>
  )
}

export default UXDesign
